import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';

const BOARDS = [
  {
    id: 'onboarding',
    label: 'Onboarding',
    path: '/workflow/onboarding',
    icon: <AccountTreeOutlinedIcon style={{ fontSize: 16 }} />,
    activeBg: 'bg-sky-500 text-white',
  },
  {
    id: 'group-deals',
    label: 'Group Deals',
    path: '/workflow/group-deals',
    icon: <GroupsOutlinedIcon style={{ fontSize: 16 }} />,
    activeBg: 'bg-violet-600 text-white',
  },
  {
    id: 'job-board',
    label: 'Job Board',
    path: '/workflow/job-board',
    icon: <AssignmentOutlinedIcon style={{ fontSize: 16 }} />,
    activeBg: 'bg-amber-400 text-[#002169]',
  },
];

const WorkflowLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div>
      <div className="flex items-center gap-3 mb-3">
        <h1 className="text-xl font-bold text-[#002169] whitespace-nowrap">Workflow</h1>

        <div className="w-px h-5 bg-gray-300 flex-shrink-0" />

        <div className="flex gap-1 bg-white rounded-xl p-1 shadow-sm border border-gray-100">
          {BOARDS.map((board) => {
            const active = location.pathname.startsWith(board.path);
            return (
              <button
                key={board.id}
                onClick={() => navigate(board.path)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all duration-150
                  ${active ? board.activeBg + ' shadow-sm' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'}`}
              >
                {board.icon}
                {board.label}
              </button>
            );
          })}
        </div>
      </div>

      <Outlet />
    </div>
  );
};

export default WorkflowLayout;
